<template>
  <div 
    :class="[
      isHome ? 'header-ranking' : 'header-fixed'
    ]"
  >
    <HeaderMobile />
    <v-app-bar
      height="56"
      color="#fff"
      class="header"
      :class="[isHome ? 'header-home' : '']"
    >
      <v-container fluid class="px-0">
        <v-row
          no-gutters
          class="flex-nowrap justify-space-between"
          align="center"
        >
          <v-col cols="auto">
            <span class="hide-md-and-up">
              <v-app-bar-nav-icon
                small
                :color="isHome ? '#fff' : '#000'"
                class="mr-4"
                @click="
                  $store.state.toggle.showSidebar = !$store.state.toggle
                    .showSidebar
                "
              >
                <template>
                  <v-icon size="25">fal fa-bars</v-icon>
                </template>
              </v-app-bar-nav-icon>
            </span>
            <v-btn
              depressed
              text
              plain
              class="px-2"
              :ripple="false"
              :to="{ name: 'homepage' }"
              color="transparent"
            >
              <icon 
                v-if="isHome"
                name="logo-white" height="35" width="90" 
              />
              <icon
                v-else
                name="logo"
                :height="$vuetify.breakpoint.md ? '40' : '35'"
                :width="$vuetify.breakpoint.md ? '109' : '90'"
              ></icon>
              
            </v-btn>
          </v-col>

          <TopMenu />

          <v-col
            cols="auto"
            class="text-right hidden-sm-and-down d-flex align-center"
          >
            <template v-if="!token">
              <router-link
                v-if="hideLoginPage"
                :to="{ name: 'login' }"
                class="text-decoration-none subtitle-1 px-4 py-2"
                :class="isHome ? 'white--text' : 'black--text'"
              >
                <translate>Sign in</translate>
              </router-link>

              <v-btn
                depressed
                color="primary"
                rounded
                class="text-none btn btn-register subtitle-2 d-none d-md-block"
                @click="$router.push({ name: 'register' }).catch((err) => {})"
              >
                <strong><translate>Become a MEMBER</translate></strong>
              </v-btn>
            </template>

            <template v-else>
              <span
                v-show="user.id"
                style="cursor: pointer"
                class="hide-sm-and-down"
                :class="isHome ? 'white--text' : 'black--text'"
              >
                <router-link :to="{ name: 'profile' }">
                  <AvatarComponent size="36" class="mr-1" isMine />
                  <span :class="isHome ? 'white--text' : 'black--text'">
                    {{ user.firstName }}
                    {{ user.lastName }}
                  </span>
                </router-link>
                <v-menu
                  eager
                  offset-y
                  tile
                  nudge-bottom="14"
                  nudge-left="140"
                  min-width="200"
                  :content-class="isHome ? 'menuManage' : 'fixed menuManage'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      plain
                      small
                      rounded
                      v-bind="attrs"
                      v-on="on"
                      class="px-2"
                      icon
                      :class="isHome ? 'white--text' : 'black--text'"
                    >
                      <v-icon>fas fa-caret-down fa-sm</v-icon>
                    </v-btn>
                  </template>
                  <v-list :elevation="0">
                    <v-list-item-group>
                      <v-list-item
                        class="pointer"
                        link
                        :to="{ name: 'profile' }"
                      >
                        <v-list-item-icon class="mr-4">
                          <v-icon size="20" class="ml-1"
                            >fas fa-user-gear</v-icon
                          >
                        </v-list-item-icon>
                        <v-list-item-content class="elevation-0 subtitle-2">
                          <translate>Manage my profile</translate>
                        </v-list-item-content>
                      </v-list-item>

                      <template v-for="course in user.courseAdmin">
                        <v-list-item
                          class="pointer"
                          v-if="course.status == 'accepted'"
                          :key="course.id"
                          link
                          :to="{
                            name: 'courses.home',
                            params: {
                              coursesCountry: course.country,
                              namegolf: course.slug,
                            },
                          }"
                        >
                          <v-list-item-icon class="mr-4">
                            <v-icon size="20" class="ml-1">fas fa-gears</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="elevation-0 subtitle-2">
                            {{ `${$gettext("Manage")} ${course.name}` }}
                          </v-list-item-content>
                        </v-list-item>
                      </template>

                      <v-list-item class="pointer" @click="logout">
                        <v-list-item-icon class="mr-4">
                          <v-icon size="20" class="ml-1"
                            >fas fa-arrow-right-from-bracket</v-icon
                          >
                        </v-list-item-icon>
                        <v-list-item-content class="elevation-0 subtitle-2">
                          <translate>Logout</translate>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </span>

              <Notification ref="notify" @pickUserInChat="pickUserInChat"/>
            </template>
            <SwitchLanguage/>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>
<script>
import { mapState } from "vuex";
import SwitchLanguage from "@/components/Header/SwitchLanguage";
import TopMenu from "@/components/Header/TopMenu";
import HeaderMobile from "@/components/Header/HeaderMobile";
import Notification from "@/components/Notification";
export default {
  name: "AppHeader",
  components: { SwitchLanguage, TopMenu, HeaderMobile, Notification },
  computed: {
    token() {
      return this.$store.state.auth.token
    },
    user() {
      return this.$store.state.auth.user
    },
    hideLoginPage() {
      if (this.$route.name === "login") return false;
      return true;
    },
    isHome() {
      if(this.$route.name === 'homepage') return true;
      if(this.$route.name.indexOf('ranking') !== -1) return true;
      return false;
    },
  },
  mounted() {
    this.$store.dispatch("fetchAvailableZoneAndCountry");
    this.$store.dispatch("getMe");
  },
  methods: {
    logout() {
      this.$refs.notify.clear()
      this.$store.dispatch("logout")
    },
    pickUserInChat(id) {
      this.$store.dispatch("chat/openChatBox", id);
    }
  },
};
</script>
